module.exports = __webpack_public_path__ + "img/media-icon.e587c5b9.svg";